module.exports = __webpack_public_path__ + "static/banner-tablet-09a89d69c28f7512c9f2bb48f79da875.png";